import React, { useState, useMemo } from 'react';
import Popover from '@mui/material/Popover';
import List from '@mui/material/List';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import _, { Dictionary } from 'lodash';
import { ExpressionFunctionSpec, PathType, specsToTypes } from '../types';

export interface Scope {
    spec: ExpressionFunctionSpec;
    id: string;
    onClose: () => void;
}

const FunctionSelectorProvider: React.FC<{
    children: (props: Scope) => React.ReactElement,
    anchorEl: Element | null,
    type: PathType,
    onClose: () => void,
}> = ({
    children,
    anchorEl,
    type,
    onClose,
}) => {
        const specs: ExpressionFunctionSpec[] = specsToTypes[type];

        return <Popover
            id={'columns-config-popover'}
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
        >
            <List dense sx={{ width: '100%', bgcolor: 'background.paper' }}>

                {
                    specs.map(spec => {
                        const { name } = spec;
                        const id = `checkbox-list-secondary-label-${spec.name}`;

                        return (
                            children({
                                spec,
                                id,
                                onClose,
                            })
                        );
                    })
                }

            </List>

            <Box textAlign='center'>
                <Button
                    onClick={onClose}
                    variant='contained'
                    sx={{ m: 1 }}
                    size='small'
                >
                    {'Ok'}
                </Button>
            </Box>
        </Popover>
    }

export default FunctionSelectorProvider;
